<template>
    <!--品牌标识管理-->
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="品牌标识">
                    <el-input v-model="search.title" placeholder="请输入品牌标识名称"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%" ref="table"
                class="custom-tbl">
                <el-table-column type="index" width="50" label="序号"> </el-table-column>
                <el-table-column prop="BrandName" label="所属品牌" width="150">
                </el-table-column>
                  <el-table-column prop="BrandLable" label="品牌标识" >
                </el-table-column>
                   <el-table-column prop="Remark" label="注释" >
                </el-table-column>
                <el-table-column prop="CreateBy" label="创建用户" width></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width></el-table-column>
                <el-table-column label="操作" width="150">
                    <template scope="scope">
                        <el-button size="small" type="primary"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('Update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                            @click="handledel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>

        <!--修改界面-->
        <el-dialog title="数据修改" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                <el-form-item label="品牌名称" prop="ProductId">
                    <el-input v-model="editForm.BrandName"  type="Text" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="品牌标识" prop="ProductId">
                    <el-input v-model="editForm.BrandLable"  type="Text" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="ProductId">
                    <el-input v-model="editForm.Remark"  type="Text" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getPBBrandManagePageList,removePBBrandManage,PostPBBrandManage} from '../../../api/api';
    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:20,
                listLoading: false,
                data:[],
                
                //修改
                editFormVisible:false,  //窗口是否显示
                editLoading:false,   //loading显示
                editForm:{
                    Id: '',
                    BrandName:'',
                    BrandLable:'',
                    Remark:'',
                },
                editFormRules: {
                    BrandName: [{ required: true, message: "请输入品牌名称", trigger: "blur" }],
                    BrandLable: [{ required: true, message: "请输入品牌标识", trigger: "blur" }]
                },

                IsAdd:true, //是否新增

            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },

            getPBBrandManagePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getPBBrandManagePageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getPBBrandManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getPBBrandManagePageList();
            },
            load(tree, treeNode, resolve) {
                let para = {
                    page: this.page,
                    id: tree.Id,
                };
                getPermissionTreeTable(para).then((res) => {
                    resolve(res.data.response);
                });
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.getPBBrandManagePageList();
            },
            //删除
            handledel(row)
            {
                console.log(row);
                 this.$confirm("确认删除该产品信息吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    removePBBrandManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getPBBrandManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = {  
                    Id: 0,
                    BrandName:'',
                    BrandLable:'',
                    Remark:''
                };
                this.firtimgList =[];
                this.IsAdd = true;
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = row;
                this.firtimgList = row.FirstPngUrl?[{url: row.FirstPngUrl}]:[];
                this.IsAdd = false;
                this.editFormVisible=true;
            },
            edithandleChange(val)
            {
                let type = this.TypeList.filter(s=>s.Id==val);
                this.editForm.Title = type? type[0].Title:'';
            },
            firtImageChange(val)
            {
                this.firtimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'FirstPng',null);
                }   
            },
            editSubmit() {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            PostPBBrandManage(para).then((res) => {
                                this.editLoading = false;
                                if (res.data.success) {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.editFormVisible = false;
                                    this.getPBBrandManagePageList();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    } else {
                        return true;
                    }

                })
            }
        },
        mounted() {
            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
           
            setTimeout(() => {
                this.GetTypeList();
            }, 500); // 3000 毫秒 = 3 秒
            this.getPBBrandManagePageList();
            
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
